import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgFacebookMessenger = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "#007fff",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		className: "fb-messenger-icon__outer-path",
		fill: "inherit",
		d: "M2.947 13.134v2.846l2.685-1.513c.748.214 1.544.33 2.368.33 4.419 0 8-3.313 8-7.399S12.419 0 8 0C3.582 0 0 3.312 0 7.398c0 2.314 1.148 4.38 2.947 5.736z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "fb-messenger-icon__inner-path",
		fill: "#FFF",
		d: "M7.146 5.372L2.83 9.899l3.927-2.135L8.809 9.9l4.29-4.527L9.216 7.47l-2.07-2.098z"
	})]
});
export default SvgFacebookMessenger;
